function Health() {
  return "Ok";
}

export default Health;
